export default __webpack_public_path__ + "static/media/H0005.1bc63712.png";